












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { Course } from '@/store/modules/course/state';
import i18n from '@/i18n';

const DISABLED_COURSES: String[] = [];
export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    courses: {
      type: Array as PropType<Course[]>,
      required: true,
    },
    selectedCourse: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.courses.map(course => {
        return {
          key: course.id,
          content: {
            title: course.name,
            disabled: DISABLED_COURSES.includes(course.name as string),
            data: [
              {
                text: i18n.t(`courseType.${course.type?.toLowerCase()}`),
                description: course.duration,
                icon: 'secretary',
                iconDescription: 'timer',
              },
            ],
          },
        } as CardInfo;
      });
      return items;
    },
  },
  methods: {
    selectedHandler({ key }: CardInfo) {
      const selectedCourse = this.courses.find(course => course.id === key);
      setTimeout(() => {
        this.$emit('selected', selectedCourse);
      }, 300);
    },
  },
});
